


































import { defineComponent, getCurrentInstance, ref } from "@vue/composition-api";
import providers from "@/lib/providers";
import emitter from "@/lib/helpers/emitter";
import { EVENTS } from "@/lib/const";
import { $t } from "@/lib/helpers/i18nHelper";
import { FormField } from "@/types";
import FieldPrinter from "@/components/FieldPrinter";

export default defineComponent({
  name: "PageForgotPassword",
  components: { FieldPrinter },
  setup() {
    const email = ref("");
    const valid = ref(true);
    const vm = getCurrentInstance();
    emitter.emit(EVENTS.LOADING.CHANGE, false);
    const fieldEmail: FormField = {
      name: "email",
      title: $t("E-mail"),
      rules: [
        (v: string) => !!v || $t("E-mail is required"),
        (v: string) => /.+@.+/.test(v) || $t("E-mail must be valid."),
      ],
    };
    const submit = async () => {
      try {
        await providers.PasswordResetProvider.start({ data: { email: email.value } });
      } finally {
        vm?.$router.push({ name: "loginForgotEmail", params: { email: email.value } });
      }
    };

    return {
      submit,
      fieldEmail,
      email,
      valid,
    };
  },
});
